module.exports = __webpack_public_path__ + "img/bca.eda9aabe.png";